import { Check } from 'lucide-react';
import { cn } from '@/utils/cn';
import Button from '@/components/ui/Button';

export interface PricingCardProps {
  title: string;
  price: string;
  regularPrice?: string;
  lowestPrice: string;
  subtitle?: string;
  savings?: string;
  features: string[];
  buttonText: string;
  isHighlighted?: boolean;
}

const PricingCard = ({
  title,
  subtitle,
  features,
  buttonText,
  isHighlighted = false,
}: PricingCardProps) => {
  const paymentLink = title === "Płatność roczna" 
    ? "https://akademialider.pl/s/rozwoj-i-zarzadzanie-szkola111223758824256364.html"
    : "https://akademialider.pl/s/rozwoj-i-zarzadzanie-szkola1112237588242563.html";

  return (
    <div className={cn(
      "bg-white rounded-2xl p-8 shadow-sm",
      isHighlighted && "border-2 border-[#FFE81A]"
    )}>
      <h3 className="text-xl text-center font-semibold text-dark mb-6">{title}</h3>
      <div className="text-center mb-2">
        <div className="flex items-center justify-center gap-2 mb-1 flex-col">
          {title === "Płatność roczna" ? (
            <span className="text-4xl font-bold text-dark">970 zł / rok</span>
          ) : (
            <>
              <span className="text-4xl font-bold text-dark">9,7 zł</span>
              <p className="text-sm text-gray-600">pierwszy tydzień, następnie 97 zł/mies.</p>
            </>
          )}
        </div>
        {subtitle && (
          <p className="text-gray-600 mt-1">{subtitle}</p>
        )}
      </div>

      <ul className="space-y-4 mb-8">
        {features.map((feature, index) => (
          <li key={index} className="flex items-center gap-3">
            <Check className="h-5 w-5 text-[#FFE81A]" />
            <span className="text-gray-600">{feature}</span>
          </li>
        ))}
      </ul>
      <a 
        href={paymentLink}
        target="_blank"
        rel="noopener noreferrer"
        className="block"
      >
        <Button
          variant={isHighlighted ? "primary" : "secondary"}
          className="w-full"
        >
          {buttonText}
        </Button>
      </a>
      {title === "Płatność roczna" && (
        <p className="text-sm text-gray-600 text-center mt-4">
          Możliwość płatności BLIK
        </p>
      )}
    </div>
  );
};

export default PricingCard;